<template src="./registration_excel.html"></template>

<script>
import XLSX from 'xlsx'
import optionData from '@/optionData/data'
import _ from 'lodash'
import flatten from 'flat'
import {ko} from 'vuejs-datepicker/dist/locale'

export default {
    name: "registration_excel",
    data() {
      return {
        ko : ko,
        role: 'licensor',
        email : null,
        state : 'verified', // 가입 상태 - 인증
        language: null,
        reference: 'other',
        marketing: true,
        notification_album : false,
        notification_sales : true,
        currency: null,
        payment_method: null,
        default_service_fee_kr: 15,                  // 한국 정산요율
        default_service_fee_other: 15,               // 해외 정산요율
        entity_tax_exemption: false,                // 면세
        roleOption: optionData.role,
        langOption: optionData.lang,
        referenceOption:optionData.reference,
        bankOption: optionData.bank,
        bankNameCode : null,
        sr_representative : null,
      
        managerList : optionData.adminList,
        
        entityOption : optionData.entity,
        countryOption : optionData.country,
        dialingOption : optionData.dialing,
        paymentOption : optionData.payment,
        currencyOption: optionData.currency,
        identificationOtion: [
          {value: 'kr_resident', label: '주민등록번호'},
          {value: 'kr_business', label: '사업자등록번호'},
          {value: 'foreign_tax', label: 'Tax No.'},
        ],
        fileList: [],
        files: [],              // 파일 데이터
        
        modals: {
          modal1: false
        },

        accept:".csv, .xls, .xlsx, text/csv, application/csv, text/comma-separated-values, application/csv, application/excel, application/vnd.msexcel, text/anytext, application/vnd. ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        extensions:'xlsx, xls, csv',
        multiple: false,
        directory: false,
        drop: true,
        dropDirectory: true,
        addIndex: false,
        thread: 3,
        name: 'file',
        uploadAuto: false,
        excelData : [],
        object :{
          bankaccount:{
            payoneer_activation_date: null,
            payoneer_customer_id: null,
            payoneer_payee_id: null,
            paypal_email : null,
            account_number: null,
            bank_branch: null,
            bank_name: null,
            bank_code : null,
            name: null,
            payment_method: null,
            address : {
              address_line: null,
              address_line2: null,
              city: null,
              district: null,
              postal_code: null,
            }
          },
          contract_end_date: null,
          contract_start_date: null,
          default_service_fee_kr: 15,
          default_service_fee_other: 15,
          company: null,
          currency: null,
          entity: null,
          ddex_partyid: null,  
          entity_address: {
            address_line: null, // 거주 주소
            address_line2: null, // 거주 주소
            country: null, // 거주 국가
            postal_code: null, // 거주 우편번호
          },
          entity_date: null,
          entity_identification: null,
          entity_identification_type: null,
          entity_tax_exemption: false,
          family_name: null,
          given_name: null,
          mims_account: null,
          nationality: null,
          phone: null,
          phone_countrycode: null,
        },
      }
    },
    watch :{
      bankNameCode(){
        if(this.bankNameCode != null){
          this.object.bankaccount.bank_code = this.bankNameCode.code
          this.object.bankaccount.bank_name = this.bankNameCode.name
        }
        
      },
      'payment_method'(data){
        if(this.payment_method == 'kr_banktransfer'){
          this.currency = 'krw'
        }else{
          this.currency = null
        }
      },
      'files'(){
        if(this.files.length != 0){
          this.handleChange()
        }
      },
      'object.nationality'(){
        if(this.object.nationality != 'KR'){
          this.object.mims_account =''
        }
      },
      'object.entity'(){
        if(this.object.entity != 'corporation'){
        
          this.object.entity_identification_type = 'kr_resident'
          this.object.company = null
          this.object.entity_tax_exemption = false
        }else{
          this.object.entity_identification_type = 'kr_business'
          
        }
        if(this.object.entity_address.country != 'KR'){
          this.object.entity_identification_type = 'foreign_tax'
        }
      },
      'object.entity_address.country'(data){
        if(this.object.entity_address.country == 'KR'){
          this.object.currency = 'krw'
          this.object.bankaccount.payment_method = 'kr_banktransfer'
          if(this.object.entity != 'corporation'){
             this.object.entity_identification_type = 'kr_resident'
          }else{
             this.object.entity_identification_type = 'kr_business'
          }
          //   {value: 'kr_resident', label: '주민등록번호'},
          //   {value: 'kr_business', label: '사업자등록번호'},
          //   {value: 'foreign_tax', label: 'Tax No.'},
        }else{
          this.object.entity_identification_type = 'foreign_tax'
          if(this.object.currency == 'krw') {
            this.object.currency = null
          }
          if(this.object.bankaccount.payment_method == 'kr_banktransfer'){
            this.object.bankaccount.payment_method = null
          }
        }
      },
      'object.bankaccount.payment_method'(){
        
      },
    },
    mounted(){
      this.$nextTick(() => {
        this.$refs.upload.drop = true
        this.$forceUpdate();
      })
    },
    methods: {
      all_saveExcel(){
        this.closeModal('confirm')
        const params = {
         
        }
        if(this.role) params['role'] = this.role                                                  // 권리자 구분
        else{
            this.alert({msg: `권리자구분 항목은 필수 항목입니다.`,}) 
            return false
        }

        if(this.valCheck(this.payment_method)){
          this.alert({msg: `지급 방법을 선택해주세요.`,}) 
          return false
        }
        if(this.valCheck(this.currency)){
          this.alert({msg: `정산 화폐를 선택해주세요.`,}) 
          return false
        }
        if(this.valCheck(this.default_service_fee_kr)){
          this.alert({msg: `국내 정산 요율을 입력해주세요.`,}) 
          return false
        }
        if(this.valCheck(this.default_service_fee_other)){
          this.alert({msg: `해외 정산 요율을 입력해주세요.`,}) 
          return false
        }
        
        
        params['state'] = this.state                                                     // 가입상태
         if(this.currency) params['currency'] = this.currency                                      // 정산화폐
        params['entity_tax_exemption'] = this.entity_tax_exemption
        params['default_service_fee_kr'] = Number(this.default_service_fee_kr)                    // 한국정산요율
        params['default_service_fee_other'] = Number(this.default_service_fee_other)              // 해외 정산요율
        
        if(this.payment_method) params['payment_method'] = this.payment_method  
        const payload = {
          file: this.files[0].file,
          data: params
        }

        if(!payload.file) {
          this.alert({msg: `파일(Excel)을 등록해주세요.`,})
          return false
        }
        this.loadingShow()
        this.$store.dispatch("POST_EXCEL_FILE_UPLOAD", payload)
        .then(result =>{
          this.loadingHide()
            this.$vs.notify({text:'사용자가 정상적으로 등록 되었습니다.',position:'top-center'})
            this.$router.push({path: '/member'});
        }).catch(error =>{
          this.loadingHide()
          const errorCode = error.response.data.code
          switch(errorCode){
            case 56:
              this.modals.modal1 = false
              this.alert({
                type: 'primary',
                message: `이미 등록된 회원입니다.`,
                icon: 'tim-icons icon-bell-55',
              })
              break;
            default:
              this.alert({
                type: 'primary',
                msg: error.response.data.message,
                icon: 'tim-icons icon-bell-55',
              })
              break;
          }

        })
      },
      send_template(params){
             // 지급방법
      },
      objectCompare(targetObj , subObj2) {
        return targetObj.map(t_obj =>{
          return t_obj.id
        }).filter(t_obj =>{
          return !subObj2.map(s_obj =>{
                  return s_obj.id
                }).includes(t_obj)
        })
      },
      handleRemove(){
        this.file = null
      },
      handleChange(){
        console.log(this.files[0].file)
        const file = this.files[0].file;
        const fileName = this.files[0].file.name;
        const reader = new FileReader(); 
        
        reader.onload = (e) => {
          let data = e.target.result; 
          data = new Uint8Array(data);
          let excelFile = XLSX.read(data, { type: "array" });
          let tmpResult = [];             
          excelFile.SheetNames.forEach(function(sheetName,index) { 
            const roa = XLSX.utils.sheet_to_json( excelFile.Sheets[sheetName], { header: 1 } ); 
              if(index == 0){
                if (roa[3]){
                  tmpResult = roa[3]
                }
              }
          });
          //0 Email ID	 //1 사업자/개인	 //2 국적	 //3 국적 ISO	 //4 거주지(소재지)국가	 //5 거주지 ISO	 //6 성	 //7 이름	
          //8 회사명	//9 MIMS 가입자명	//10 연락처국가	//11 국가번호	//12 연락처번호	//13 납세자번호(숫자만)	//14 생년월일(설립연월일)	
          //15 주소	//16 상세주소	//17 우편번호	//18 정산화폐	//19 정산방법	//20 예금주	//21 계좌번호	//22 은행명	//23 은행코드	//24 Paypal E-mail 
          this.excelData = tmpResult;
          console.log(this.excelData)
          //0
          this.email =  this.excelData[0] ? this.excelData[0] : null
          
          //1 ,8 
          if(this.excelData[1] == '사업자'){
            this.object.entity = 'corporation'
            this.object.company = this.excelData[8]? this.excelData[8] : null
          }else if(this.excelData[1] == '개인'){
            this.object.entity = 'individual'
            
          }else if(this.excelData[1] == '면세사업자'){
            this.object.entity = 'corporation'
            this.object.company = this.excelData[8]? this.excelData[8] : null
            this.object.entity_tax_exemption =true
          }else{
            this.object.entity = null
          }
          //3 국가
          this.object.nationality = this.excelData[3] ? this.excelData[3] : null

          //4,5 15,16,17
          this.object.entity_address = {
            address_line: this.excelData[15] ? this.excelData[15]  : null, // 거주 주소
            address_line2: this.excelData[16] ? this.excelData[16]  : null, // 거주 주소
            country: this.excelData[5]  ? this.excelData[5]  : null, // 거주 국가
            postal_code: this.excelData[17] ? String(this.excelData[17] + '')  : null, // 거주 우편번호
          }
          if(this.object.entity != 'corporation'){
            this.object.entity_identification_type = 'kr_resident'
            this.object.company = null
            this.object.entity_tax_exemption = false
          }else{
            this.object.entity_identification_type = 'kr_business'
          }
          if(this.object.entity_address.country != 'KR'){
            this.object.entity_identification_type = 'foreign_tax'
          }
 
          //13
          this.object.entity_identification = this.excelData[13] ? this.excelData[13] : null
          
          //14
          if(this.excelData[14]){
            let year = String(this.excelData[14]).substring(0, 4);
            let month = String(this.excelData[14]).substring(4, 6);
            let day = String(this.excelData[14]).substring(6, 8);
            let dd = year + '-' + month + '-' + day;
             this.object.entity_date = String(this.excelData[14]) ? dd : null
          }
          
          //6,7
          this.object.family_name = this.excelData[6] ? this.excelData[6] : null
          this.object.given_name = this.excelData[7] ? this.excelData[7] : null
          //9
          this.object.mims_account = this.excelData[9] ? this.excelData[9] : null
         
          //11,12
          this.object.phone=this.excelData[12] ? String(this.excelData[12]) : null
          this.object.phone_countrycode=this.excelData[11] ? this.excelData[11] : null
          //18 정산화폐	//19 정산방법	//20 예금주	//21 계좌번호	//22 은행명	//23 은행코드	//24 Paypal E-mai
          
          this.object.currency=this.excelData[18] ? this.excelData[18].toLowerCase() : null

          this.bankNameCode = {name: this.excelData[22] ? this.excelData[22] : null, code: this.excelData[23] ? this.excelData[23] : null}
          this.object.bankaccount = {
              paypal_email : this.excelData[24] ? this.excelData[24] : null,
              account_number: this.excelData[21] ? this.excelData[21] : null,
              bank_branch: null,
              bank_name: this.excelData[22] ? this.excelData[22] : null,
              bank_code : this.excelData[23] ? this.excelData[23] : null,
              name: this.excelData[20] ? this.excelData[20] : null,
              payment_method: this.object.currency == "KRW" ? "kr_banktransfer" : "paypal" ,
              address : {
                address_line: null,
                address_line2: null,
                city: null,
                district: null,
                postal_code: null,
              }
          }
        }
        reader.readAsArrayBuffer(file);

      },
      all_save(){
        
        this.closeModal('confirm')
        let params = {
          state : 'verified', // 가입 상태 - 인증
          role: this.role,
          email: this.email,
          language: this.language,
          reference: this.reference,
          marketing: this.marketing,
          notification_album : this.notification_album,
          notification_sales : this.notification_sales,
        }
        if(this.role != 'admin' ){
          params['sr_representative'] = this.sr_representative
        }
        let checkList = [];
        if(this.nullCheck(this.language)){
          this.alert({msg:'사이트 언어를 선택해주세요.'})
          return false;
        }
        if(this.nullCheck(this.email)){
          this.alert({msg:'이메일을 입력해주세요.'})
          
          return false;
        }
        let emailReg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		    if (!emailReg.test(this.email)) { // 이메일 정규식 체크
          this.alert({msg:'이메일형식이 맞지 않습니다.'});
          return false;
        }
        try {
            new Date(this.object.entity_date).toISOString();
        } catch (e) { 
            console.log(this.object.entity_date)
            this.object.entity_date = null
            
        }
        if(this.role == 'licensor'){
            let licensor = { licensor :this.object }
            params = Object.assign(params, licensor)
            // 필요없는 property 삭제
            delete params.licensor.contract_start_date; 
            delete params.licensor.contract_end_date; 
            
            console.log(params)
            //라이센서 체크 리스트
            checkList = [
              'nationality',
              'entity',
              'family_name',
              'given_name',
              'entity_address.country',
              'currency',
              'bankaccount.payment_method',
              'entity_identification',
              'default_service_fee_kr',
              'default_service_fee_other',
              ]
            if(params.entity == "corporation"){
              checkList.push('company')
            }
            
        }else if(this.role == 'contractor'){
          // contractor check List 
          let contractor = { contractor : this.object}
          params = Object.assign(params, contractor)
          // 필요없는 property 삭제
          delete params.contractor.ddex_partyid; 
          delete params.contractor.mims_account; 
          
          checkList = [
              'nationality',
              'family_name',
              'given_name',
              'entity',
              'entity_address.country',
              'currency',
              'bankaccount.payment_method',
              'entity_identification',
              'default_service_fee_kr',
              'default_service_fee_other',
              'contract_end_date',
              'contract_start_date']
          if(params.entity == "corporation"){
            checkList.push('company')
          }
        }
      
        // 지급방법별 체크
        let checkList2 = []
        if(this.object.bankaccount.payment_method == 'kr_banktransfer'){
            checkList2 = [
              'bankaccount.name',
              'bankaccount.bank_code',
              'bankaccount.bank_name',
              'bankaccount.account_number',
            ]
            this.object.bankaccount.bank_branch = null
            this.object.bankaccount.paypal_email = null
            this.object.bankaccount.address = {
              address_line: null,
              address_line2: null,
              city: null,
              district: null,
              postal_code: null,
            }
          }
        if(this.object.bankaccount.payment_method == 'intl_banktransfer'){
          checkList2 = [
            'bankaccount.name',
            'bankaccount.bank_branch',
            'bankaccount.account_number',

            'bankaccount.address.address_line',
            // 해외 이체 시 주소 1만 입력
            // 'bankaccount.address.address_line2',
            // 'bankaccount.address.city',
            // 'bankaccount.address.district',
            // 'bankaccount.address.postal_code',
        ]
          this.object.bankaccount.bank_name = null
          this.object.bankaccount.paypal_email = null
        }
        if(this.object.bankaccount.payment_method == 'paypal'){
          checkList2 = [
              'bankaccount.paypal_email'
          ]
          this.object.bankaccount.name = null
          this.object.bankaccount.bank_code = null
            this.object.bankaccount.account_number = null
            this.object.bankaccount.address = {
            address_line: null,
            address_line2: null,
            city: null,
            district: null,
            postal_code: null,
          }
        }

        
        if(this.object.nationality.length !== 2) {
          this.alert({msg : '국적을 확인해주세요.'})
          return false
        }
        if(this.object.entity_address.country.length !== 2){
          this.alert({msg : '거주국가를 확인해주세요.'})
          return false
        }
        checkList = _.concat(checkList, checkList2);
        
        //라이센서 컨트랙터 필수값 체크
        
        if(checkList.length > 0 && !this.allNullCheck(checkList)){
          console.log(this.allNullCheck(checkList))
          return false
        }
        this.bankNameCode = null
        
        this.loadingShow()
        
        const payload = {params: params}

        this.$store.dispatch("POSTUSER", payload)
        .then(result =>{
          this.loadingHide();
          this.$vs.notify({text:'사용자가 정상적으로 등록 되었습니다.',position:'top-center'})
          this.$router.push({path: '/member'})
        }).catch(error =>{
          this.loadingHide();
          switch(error.response.data.code) {
            case 56:
              this.alert({
                msg : '이미 등록된 유저입니다.'
              }) 
              break;
            default:
              this.alert({msg:error.response.data.message})
              break;
          }
        })
      },
      nullCheck(data){
        if(data == '' || data == null){
          return true
        }else{
          return false
        }
        
      },
      allNullCheck( checkList){
        let t = flatten(this.object)
        console.log(t);
        let msgList = {
          'entity' :'사업자구분을 선택해주세요.',
          'phone_countrycode' : '전화번호를입력해주세요.', 
          'phone' : '전화번호를입력해주세요.',
          'nationality' : '국가를 선택해주세요.',
          'company'  : '회사명을 입력해주세요.',
          'bankaccount.payment_method': '지급방법을 선택해주세요.' ,
          'entity_identification' : '납세자번호를 입력해주세요.',
          'currency' : '정산화폐를 선택해주세요.',
          'entity_address.country' : '거주국가를 선택해주세요.',
          'entity_date' : '생년월일(회사설립일을 입력해주세요.)',
          'entity_address.address_line':'거주지 주소를 입력해주세요.' ,
          'family_name': '성명을 모두 입력해주세요.' ,
          'given_name' : '성명을 모두 입력해주세요.',
          'default_service_fee_kr' : '국내정산요율을 입력해주세요',
          'default_service_fee_other' : '해외정산요율을 입력해주세요',
          'bankaccount.name' : '예금주를 입력해주세요.',
          'bankaccount.bank_code' : '은행코드를 입력해주세요.',
          'bankaccount.bank_name' :'은행명을 입력해주세요.' ,
          'bankaccount.bank_branch' : 'Bank Name을 입력해주세요',
          'bankaccount.account_number': '계좌번호를 입력해주세요',
          'bankaccount.address.address_line': 'Branch 주소를 입력해주세요.',
          'bankaccount.address.address_line2': 'Branch 상세주소를 입력해주세요.',
          'bankaccount.address.city': 'Branch City를 입력해주세요.',
          'bankaccount.address.district' : 'Branch District를 입력해주세요.',
          'bankaccount.address.postal_code' : 'Branch 우편번호를 입력해주세요.',
          'bankaccount.paypal_email' : 'Paypal ID를 입력해주세요.',
          'contract_end_date' : '계약 종료을 입력해주세요.', 
          'contract_start_date': '계약 시작일을 입력해주세요.',
        }
        for(var i in checkList){
          console.log(t[checkList[i]] )
          if(t[checkList[i]] == null || t[checkList[i]] == ''){
          
            this.alert({msg:msgList[checkList[i]]})
            return false;
          }
          
        }
        return true;
      },
      closeOpen(modalNo){
        return new Promise(resolve =>{
          resolve(this.modals[modalNo] = false)
        })
      },


     
    }
}
</script>

<style  lang="scss" scoped>


.el-upload-dragger {
  background: transparent !important;
  background-color: #000 !important;
}
.el-upload {
  width: 100%;
}

</style>